import axiosConfig from "./axiosConfig";

class NiveauService {
  async getAll() {
    try {
      const response = await axiosConfig.get("/niveaux");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching niveaux:", error);
      return [];
    }
  }

  async create(formData) {
    try {
      const response = await axiosConfig.post("/niveaux", formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la création:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async update(id, formData) {
    try {
      const response = await axiosConfig.put(`/niveaux/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la mise à jour:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async delete(id) {
    try {
      const response = await axiosConfig.delete(`/niveaux/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la suppression:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }
}

const NiveauServiceInstance = new NiveauService();
export default NiveauServiceInstance;
